export const getVisitTypeLocalization = (visitTypeName: string, t: (key: string) => string, description?: boolean) => {
    if (description) {
        return t(`visitTypes.${visitTypeName.toLowerCase().replace(/\s+/g, '_')}_description`)
    }
    return t(`visitTypes.${visitTypeName.toLowerCase().replace(/\s+/g, '_')}`)
}